import { render } from "./CoverDetail.vue?vue&type=template&id=41a52e60&scoped=true"
import script from "./CoverDetail.vue?vue&type=script&lang=js"
export * from "./CoverDetail.vue?vue&type=script&lang=js"

import "./CoverDetail.vue?vue&type=style&index=0&id=41a52e60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a52e60"]])

export default __exports__